import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router";
import { Analytics } from "@vercel/analytics/react"
import { SpeedInsights } from "@vercel/speed-insights/react"
import "./index.css";

import "bootstrap/dist/css/bootstrap.min.css";

import Header from "./components/header/header";
// import Footer from "./components/footer/footer";
import TipJarFooter from "./components/tipJarFooter/tipFooter";
import Loading from "./components/loading/Loading";
const Home = React.lazy(() => import("./pages/home/home"));
const OwnTheView = React.lazy(() => import("./pages/owntheview"));
const Boys = React.lazy(() => import("./pages/boys"));
// const Circus = React.lazy(() => import("./pages/circus"));
const AFewThings = React.lazy(() => import("./pages/afewthings"));
const Skylines = React.lazy(() => import("./pages/skylines"));
const MakingMyName = React.lazy(() => import("./pages/makingmyname"));
const Shows = React.lazy(() => import("./pages/shows"));
const Merch = React.lazy(() => import("./pages/merch/merch"));
const NotFound = React.lazy(() => import("./components/subpages/notFound/notFound"));
const Gallery = React.lazy(() => import("./pages/gallery/index"));

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <BrowserRouter>
    <Header />

    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="albums">
          {/* <Route path="thecircusofthegrieving" element={<Circus />} /> */}
          <Route path="owntheview" element={<OwnTheView />} />
          <Route path="afewthingsibelieve" element={<AFewThings />} />
          <Route path="makingmyname" element={<MakingMyName />} />
          <Route path="skylines" element={<Skylines />} />
          <Route path="boys" element={<Boys />} />
        </Route>
        <Route path="*" element={<NotFound />} />
        <Route path="shows" element={<Shows />} />
        <Route path="merch" element={<Merch />} />
        <Route path="gallery" element={<Gallery />} />
      </Routes>
    </Suspense>
    <TipJarFooter />
     {/* <Footer /> */}
    <Analytics />
    <SpeedInsights />
   
  </BrowserRouter>
);
